import {Component} from '@angular/core';
import {FieldType, FieldTypeConfig} from '@ngx-formly/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-file-input',
    template: ` <input type="file"
                       [formControl]="formControl"
                       [formlyAttributes]="field"
                       [multiple]="to.multiple"
                       [accept]="to.accept"
                       class="p-inputtext p-component p-element"/>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldFileInputType extends FieldType<FieldTypeConfig> {
}
